module.exports = __webpack_public_path__ + "static/fonts/Fact-ThinItalic.ffcaca9.woff2";